<template>
  <input
    v-bind="bindAttrs"
    @keydown="checkDirty($event, 'keydown')"
    @keypress="$emit('keypress', $event)"
    @blur="checkDirty($event, 'blur')"
    @keyup="checkDirty($event, 'keyup')"
    @input="checkDirty($event.target.value, 'input')"
    ref="blInput"
  />
</template>

<script>
import { omitBy } from '@/utils/lodash'
export default {
  name: 'BLInput',
  data () {
    return {
      isDirty: false
    }
  },
  computed: {
    bindAttrs () {
      return omitBy(this.$attrs, [])
    }
  },
  mounted () {
    this.isDirty = false
    this.$refs.blInput.onchange = this.onChange
  },
  methods: {
    onChange (e) {
      this.$emit('change', e.target.value)
      this.isDirty = true
    },

    handleNextInput (currentInputId) {
      const [rowId, inputId] = currentInputId.split('_')
      let nextInputId

      if (+inputId === 3) {
        nextInputId = `${+rowId + 1}_1`
      } else {
        nextInputId = `${rowId}_${+inputId + 1}`
      }

      const nextDataInputIdSelector = `[data-input-id='${nextInputId}']`
      const currentDataInputErrorSelector = `[data-input-id-error='${currentInputId}']`
      const nextInput = document.querySelector(nextDataInputIdSelector)

      this.$nextTick(() => {
        const currentInputError = document.querySelector(
          currentDataInputErrorSelector
        )

        if (!currentInputError && nextInput) {
          nextInput.focus()
        }
      })
    },

    checkDirty (e, eventName) {
      if (!this.isDirty && !this.$refs.blInput.value) return

      if (eventName === 'keyup' && e.key === 'Enter') {
        this.$refs.blInput.blur()
        const currentInputId = this.$attrs['data-input-id']
        this.handleNextInput(currentInputId)

        return
      }

      this.$emit(eventName, e)
    }
  }
}
</script>
